import React from 'react';

interface IProps {
  style?: any;
}

const UncheckBoxIcon:React.FC<IProps> = (props: IProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="21" fill="none" viewBox="0 0 23 21">
      <rect width="22" height="20" x=".5" y=".5" stroke={props.style?.strokeColor ? props.style.strokeColor : "#122442"} strokeOpacity=".2" rx="1.5"/>
    </svg>
  )
}

export default UncheckBoxIcon;